//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'cityList',
    data() {
        const vm = this;
        return {
            searchInput: {},
            showCityModel: false,
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '城市名称',
                    key: 'name',
                    align: 'center'
                },
                {
                    title: '城市代码',
                    key: 'cityCode',
                    align: 'center'
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delCity(params.row);
                                }
                            }
                        }, '删除');

                        if (vm.hasPermission('Pages.ProjectManage.City.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    // ghost:true,
                                },
                                style: {
                                    marginRight: '5px',
                                },
                                on: {
                                    click: () => {
                                        vm.editCity(params.row);
                                    }
                                }
                            }, '编辑'));
                        }
                        if (vm.hasPermission('Pages.ProjectManage.City.Delete')) {
                            actions.push(del);
                        }
                        return h('div', actions);
                    }
                }
            ],
            rules: {
                name: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ],
                cityCode: [
                    { required: true, message: '不能为空', trigger: 'blur' }
                ]
            },
            cityInfo: {
                areaCodeArr: []
            },
            mTitle: '新增',
            saving: false
        };
    },
    computed: {
        currentPage() {
            return this.$store.state.city.currentPage;
        },
        totalCount() {
            return this.$store.state.city.totalCount;
        },
        pageSize() {
            return this.$store.state.city.pageSize;
        },
        list() {
            return this.$store.state.city.list;
        }
    },
    methods: {
        pageChange(page) {
            this.$store.commit('city/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('city/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'city/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        save() {
            this.cityInfo.areaCode = JSON.stringify(this.cityInfo.areaCodeArr);
            // console.log(this.cityInfo);
            if (!this.cityInfo.name) {
                return;
            }
            // return;
            // this.$refs.cityForm.validate(async (val) => {
            //     if (val) {
            this.saving = true;
            this.$store
                .dispatch({
                    type: 'city/saveCity',
                    data: this.cityInfo
                })
                .then(() => {
                    this.loading = false;
                    this.showCityModel = false;
                    this.getPage();
                }).finally(() => {
                this.saving = false;
            });
            //     }
            // });
        },
        cancel() {
            this.cityInfo = {
                areaCodeArr: []
            };
            this.showCityModel = false;
        },
        editCity(city) {
            if (city.id > 0) {
                this.mTitle = '编辑';
            } else {
                this.mTitle = '新增';
            }
            // this.specification = JSON.parse(JSON.stringify(spec));
            //JSON.stringify(newValue);
            this.cityInfo = {};
            this.cityInfo = JSON.parse(JSON.stringify(city));
            if (this.cityInfo.areaCode) {
                this.cityInfo.areaCodeArr = JSON.parse(this.cityInfo.areaCode);
            } else {
                this.cityInfo.areaCodeArr = [];
            }
            // console.log(JSON.stringify(this.cityInfo.areaCode));

            this.showCityModel = true;
            this.saving = false;
        },
        delCity(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    await this.$store.dispatch({
                        type: 'city/delCity',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.getPage();
                    }).finally(() => {

                    });

                }
            });
        },
        onAreaChange(d) {
            if (d.length < 2) {
                return;
            }
            // console.log(d);
            this.cityInfo.cityAreaCode = d[1].code;
            this.cityInfo.name = d[1].name;
            if (d[1].name === '市辖区') {
                this.cityInfo.name = d[0].name;
            }
            this.cityInfo.areaCodeArr = [];
            var arr = [];
            for (var i = 0; i < d.length; i++) {
                this.cityInfo.areaCodeArr.push(d[i].code);
                arr.push(d[i].name);
            }
            this.cityInfo.areaName = JSON.stringify(arr);

        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    }
};
